import type { SendFeedbackParams } from './Feedback.types';
import type { DefaultResponse } from '@/shared/api';
// TODO: fix import from upper layer
import { serializeToFormData } from '@/app/plugins/http/http.utils';
import { BaseService, defineApi } from '@/shared/api';

class FeedbackService extends BaseService {
  async sendFeedback(params: SendFeedbackParams): Promise<DefaultResponse> {
    const formData = serializeToFormData(params, false);
    return await this.post('/sendfeedback', formData);
  }
}

export const useFeedbackService = defineApi(FeedbackService);
